import './App.css';
import FireAnimation3D from './components/FireAnimation3D';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, NavLink, useNavigate } from 'react-router-dom';

// Import pages
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import Portfolio from './pages/Portfolio';

function HomePage() {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact');
  };

  useEffect(() => {
    // Scroll progress indicator
    const updateScrollProgress = () => {
      const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrolled = (winScroll / height) * 100;
      document.querySelector('.scroll-progress').style.width = scrolled + '%';
    };

    // Add event listener
    window.addEventListener('scroll', updateScrollProgress);
    
    // Clean up
    return () => window.removeEventListener('scroll', updateScrollProgress);
  }, []);

  // Featured portfolio projects for homepage
  const featuredProjects = [
    {
      id: 1,
      title: 'E-Commerce Platform',
      category: 'web',
      image: '/assets/portfolio/e-commerce.jpg',
      description: 'Complete e-commerce solution with product management, payment integration, and customer analytics, together with an app which is mainly for the loyalty program. Please contact me for more info and demo.',
      technologies: ['Laravel', 'MySQL', 'Bootstrap', 'Payment Gateway', 'Delivery Partner Integration'],
      link: '#'
    },
    {
      id: 2,
      title: 'PropertyMart.Com.My',
      category: 'web/app',
      image: '/assets/portfolio/pm-logo-bgpink.jpg',
      description: 'PropertyMart.Com.My is a property listing website that allows users to list their properties for sale or rent.',
      technologies: ['React', 'Laravel', 'MySQL', 'Tailwind CSS', 'CRM'],
      link: 'https://www.propertymart.com.my'
    },
    {
      id: 3,
      title: 'Gold Trading Platform',
      category: 'app',
      image: '/assets/portfolio/my-transaction-gold.png',
      description: 'Gold Trading Platform is a platform that allows users to buy and sell gold. Please contact me for more info and demo.',
      technologies: ['Flutter', 'Firebase', 'Payment Gateway', 'API Integration', 'KYC'],
      link: '#'
    }
  ];

  return (
    <div className="w-full">
      {/* Scroll Progress Indicator */}
      <div className="scroll-progress"></div>
      
      {/* Hero Section */}
      <header className="bg-white">
        <div className="container">
          <div className="flex justify-between items-center py-8 flex-col-mobile">
            <div>
              <h1 className="mb-4">
                Unleash the Flame of <span className="text-flame">Ignite Your Digital</span> Transformation with
              </h1>
              <p className="mb-8 text-gray-600">Transforming ideas into powerful software solutions</p>
              <button className="btn" onClick={handleContactClick}>Get Started</button>
            </div>
            <div>
              <img src="/laptop.png" alt="Digital Transformation" className="hero-logo" />
            </div>
          </div>
        </div>
      </header>

      {/* Services Section */}
      <section className="section bg-gray-50">
        <div className="container">
          <h2 className="section-title">Crafting Innovative Solutions</h2>
          <div className="flex justify-between flex-col-mobile">
            <div className="card text-center">
              <div className="mb-4">🔥</div>
              <h3 className="mb-4">Responsive Web Design</h3>
              <p className="text-gray-600">Creating beautiful, functional websites</p>
            </div>
            <div className="card text-center">
              <div className="mb-4">🔥</div>
              <h3 className="mb-4">Custom App Development</h3>
              <p className="text-gray-600">Tailored solutions for your business</p>
            </div>
            <div className="card text-center">
              <div className="mb-4">🔥</div>
              <h3 className="mb-4">Maintenance & Support</h3>
              <p className="text-gray-600">Ongoing care for your digital products</p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Portfolio Section */}
      <section className="section bg-gray-50">
        <div className="container">
          <h2 className="section-title">Featured <span className="text-flame">Projects</span></h2>
          <p className="text-center mb-8 text-gray-600">Explore some of our most impactful digital transformation solutions</p>
          
          <div className="portfolio-grid">
            {featuredProjects.map(project => (
              <div key={project.id} className="portfolio-item">
                <div className="portfolio-image-container">
                  <img src={project.image} alt={project.title} className="portfolio-image" />
                  <div className="portfolio-overlay">
                    <a href={project.link} className="btn view-project-btn">View Project</a>
                  </div>
                </div>
                <div className="portfolio-content">
                  <h3>{project.title}</h3>
                  <p className="text-gray-600">{project.description}</p>
                  <div className="tech-tags">
                    {project.technologies.map((tech, index) => (
                      <span key={index} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center" style={{ marginTop: '5rem' }}>
            <Link to="/portfolio" className="btn">View All Projects</Link>
          </div>
        </div>
      </section>

      {/* Digital Future Section */}
      <section className="section bg-white">
        <div className="container">
          <h2 className="section-title">Empowering Your Digital Future</h2>
          <div className="flex items-center flex-col-mobile">
            <div>
              <img src="/assets/growth.png" alt="Software Developer" className="rounded" />
            </div>
            <div>
              <p className="mb-8 text-gray-600">At OnFire Software Solutions, we're passionate about helping businesses succeed in the digital landscape. Our team of experts works tirelessly to create innovative solutions that drive growth and enhance your online presence.</p>
              <button className="btn" onClick={handleContactClick}>Contact Us</button>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/* <section className="section bg-gray-50">
        <div className="container">
          <h2 className="section-title">Pioneering the Future of Software</h2>
          <div className="flex justify-center py-8 flex-col-mobile">
            <div className="text-center">
              <img src="/team-member1.png" alt="Team Member" className="mb-4" style={{borderRadius: '50%', width: '150px', height: '150px'}} />
              <h3 className="mb-4">James Mong</h3>
              <p className="text-gray-600">Founder of OnFire</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Second Features Section */}
      <section className="section bg-white">
        <div className="container">
          <div className="ignite-flex">
            <div>
              <h2 className="mb-4">Ignite Your Digital</h2>
              <p className="mb-8 text-gray-600">Transform your business with our innovative solutions.</p>
              <button className="btn" onClick={handleContactClick}>Get Started</button>
            </div>
            <div>
              <img src="/assets/ignite.png" alt="Digital Work" className="ignite-image" />
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-flame text-white py-16 text-center">
        <div className="container">
          <h2 className="mb-4">Empowering</h2>
          <p className="mb-8">Ready to transform your digital presence?</p>
          <button className="btn btn-white" onClick={handleContactClick}>Contact Us Today</button>
        </div>
      </section>
    </div>
  );
}

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.nav-links') && !event.target.closest('.hamburger')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMenuOpen]);

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, []);

  return (
    <Router>
      {/* Navigation */}
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <NavLink to="/" className="nav-logo">
              <img src="/logo-nobg.png" alt="OnFire" />
            </NavLink>
            
            <div className={`hamburger ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
              <div className="hamburger-line"></div>
            </div>

            <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
              <NavLink to="/" className={({ isActive }) => isActive ? 'nav-active' : ''}>
                Home
              </NavLink>
              <NavLink to="/about" className={({ isActive }) => isActive ? 'nav-active' : ''}>
                About
              </NavLink>
              <NavLink to="/services" className={({ isActive }) => isActive ? 'nav-active' : ''}>
                Services
              </NavLink>
              <NavLink to="/portfolio" className={({ isActive }) => isActive ? 'nav-active' : ''}>
                Portfolio
              </NavLink>
              <NavLink to="/contact" className={({ isActive }) => isActive ? 'nav-active' : ''}>
                Contact
              </NavLink>
            </div>
          </div>
        </div>
      </nav>
      {isMenuOpen && <div className="menu-overlay active" onClick={toggleMenu}></div>}

      {/* Routes */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      {/* Footer - Common across all pages */}
      <footer className="footer">
        <div className="container">
          <div className="flex justify-between flex-col-mobile">
            <div>
              <h2 className="nav-logo mb-4">OnFire</h2>
            </div>
            <div className="footer-columns-container">
              <div className="footer-column">
                <h3>Company</h3>
                <Link to="/about">About Us</Link>
                <Link to="/services">Services</Link>
                <Link to="/portfolio">Portfolio</Link>
              </div>
              <div className="footer-column">
                <h3>Resources</h3>
                <a href="#blog">Blog</a>
                <a href="#docs">Documentation</a>
                <a href="#faq">FAQs</a>
              </div>
              <div className="footer-column">
                <h3>Contact</h3>
                <Link to="/contact">Get in Touch</Link>
                <a href="#support">Support</a>
                <a href="#careers">Careers</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      
      {/* Epic 3D Fire Animation that appears on scroll */}
      <FireAnimation3D />
    </Router>
  );
}

export default App;
